






































import { Component, Vue } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import { InteractionModel } from '@/app/shared/models';
import TabItemGeneral from '@/app/shared/components/tabs/item-general.vue';
import TabItemPaymentHistory from '@/app/shared/components/tabs/item-payment-history.vue';
import TabItemServiceRecord from '@/app/shared/components/tabs/item-service-record.vue';
import TabItemCampaign from '@/app/shared/components/tabs/item-campaign.vue';
import TabItemWebhookEvent from '@/app/shared/components/tabs/item-webhook-event.vue';

@Component({
  components: {
    TabItemGeneral,
    TabItemPaymentHistory,
    TabItemServiceRecord,
    TabItemCampaign,
    TabItemWebhookEvent,
  },
})
export default class TabContractComponent extends Vue {
  public activeTab = null;

  public get refs() {
    return refsService;
  }

  public async loadPaymentInfo() {
    this.refs.modules.contract.loadPaymentInfoByContractId(
      this.$route.params.id
    );
  }

  public async consultServiceRecord() {
    if (!this.refs.modules.ticket.consultServiceRecord) {
      this.refs.modules.ticket.SET_CONSULT_SERVICE_RECORD(true);
      this.refs.modules.ticket.createInteraction(
        new InteractionModel(
          this.$t('action_code.ac0'),
          this.$t('action_desc.ad5')
        )
      );
    }
  }
  public async consultPaymentHistory() {
    if (!this.refs.modules.ticket.consultPaymentHistory) {
      this.refs.modules.ticket.SET_CONSULT_PAYMENT_HISTORY(true);
      this.refs.modules.ticket.createInteraction(
        new InteractionModel(
          this.$t('action_code.ac0'),
          this.$t('action_desc.ad4')
        )
      );
    }
  }
  public async consultCampaign() {
    if (!this.refs.modules.ticket.consultPaymentHistory) {
      this.refs.modules.ticket.SET_CONSULT_CAMPAIGN(true);
      this.refs.modules.ticket.createInteraction(
        new InteractionModel(
          this.$t('action_code.ac0'),
          this.$t('action_desc.ad55')
        )
      );
    }
  }
  public async consultWebhookEvent() {
    if (!this.refs.modules.ticket.consultWebhookEvent) {
      this.refs.modules.ticket.SET_CONSULT_WEBHOOK_EVENT(true);
      this.refs.modules.ticket.createInteraction(
        new InteractionModel(
          this.$t('action_code.ac0'),
          this.$t('action_desc.ad61')
        )
      );
    }
  }
}
